var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEyeSymbolOutlined(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0.21 0.18 15.57 11.64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.682 5.54C13.99 1.974 11.43.18 8 .18 4.568.18 2.01 1.974.318 5.542a1.077 1.077 0 0 0 0 .92c1.693 3.566 4.252 5.36 7.682 5.36 3.432 0 5.99-1.794 7.682-5.362.138-.29.138-.625 0-.92ZM8 10.537c-2.88 0-4.99-1.46-6.477-4.536C3.011 2.926 5.12 1.465 8 1.465c2.88 0 4.99 1.461 6.477 4.536C12.99 9.076 10.882 10.537 8 10.537ZM7.93 2.858a3.143 3.143 0 1 0 0 6.286 3.143 3.143 0 0 0 0-6.286Zm0 5.143a1.999 1.999 0 1 1 0-4 1.999 1.999 0 1 1 0 4Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeSymbolOutlined);
export default __webpack_public_path__ + "static/media/eye-symbol-outlined.97260078465a99efe37e4df9457430cf.svg";
export { ForwardRef as ReactComponent };